module.exports = __webpack_public_path__ + "img/cyd_florias.e8bcc3d0.jpg";